<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({
  label: { type: String, default: '' },
  countdown: { type: Number, default: 0 },
  verifyCodeDisabled: { type: Boolean, default: false },
});

const emit = defineEmits(['send-verify-code']);

const handleSendVerifyCode = () => {
  emit('send-verify-code');
};
</script>

<template>
  <div class="relative" :class="{ 'field-has-value': $attrs.value }">
    <a-input v-bind="$attrs" class="placeholder-25">
      <template #suffix>
        <span
          v-if="props.countdown > 0"
          class="text-sm font-normal text-colorTextQuaternary"
          >重新发送({{ props.countdown }}s)</span
        >
        <a-button
          v-else
          type="link"
          size="small"
          class="!absolute right-1 !text-sm !text-primary hover:!text-primaryhover disabled:!text-colorTextTertiary"
          :disabled="props.verifyCodeDisabled"
          @click="handleSendVerifyCode"
        >
          获取验证码
        </a-button>
      </template>
    </a-input>
    <span class="form-field-label">{{ props.label }}</span>
  </div>
</template>

<style scoped>
:deep(.placeholder-25 .ant-input) {
  @apply leading-6;
}
</style>
